import type { ReactNode } from "react"

interface NoAvailablePanelProps {
    children?: ReactNode
}
export function NoAvailablePanel({ children }: Readonly<NoAvailablePanelProps>) {
    return <div className="flex w-full justify-center p-2 text-gray-500">{children}</div>
}
